import * as Sentry from '@sentry/browser';
import { redact } from '../core/redact.js';
/**
 * Browser telemetry, for `apps/admin`.
 *
 * The third platform on the same spine rather than a second spine: one redaction
 * deny-list, one correlation-id convention, three Sentry projects. The projects are
 * separate because their stack-trace formats are — a minified browser bundle, a
 * Hermes bundle, and a Node stack each symbolicate differently, which is the same
 * reason the React Native and Node projects were split.
 *
 * Deliberately no OpenTelemetry. Browser tracing on a single-user internal tool buys
 * resolution nobody is asking for and costs a collector to receive it.
 */
export const CORRELATION_ID_TAG = 'correlationId';
let started = false;
/**
 * Returns false when no DSN is configured. That is a supported state rather than a
 * failure: `VITE_SENTRY_DSN` is optional and the admin must run without it.
 */
export function initBrowserTelemetry(options) {
    if (started)
        return true;
    if (options.dsn === undefined || options.dsn === '')
        return false;
    started = true;
    const init = options.init ?? Sentry.init;
    const getCorrelationId = options.getCorrelationId;
    init({
        dsn: options.dsn,
        release: options.release,
        environment: options.environment,
        // The same deny-list the server and the app use. Two implementations drift, and
        // the one that drifts is the one nobody is testing.
        //
        // Redaction runs first and the tag is written onto its result: a tag added
        // before the walk would be at the mercy of a future deny-list entry, and an id
        // that silently stops arriving is worse than never having had one.
        beforeSend: (event) => {
            const cleaned = redact(event);
            if (getCorrelationId) {
                cleaned.tags = {
                    ...cleaned.tags,
                    [CORRELATION_ID_TAG]: getCorrelationId(),
                };
            }
            return cleaned;
        },
        beforeBreadcrumb: (breadcrumb) => redact(breadcrumb),
    });
    return true;
}
/** Test-only. */
export function resetBrowserTelemetryForTesting() {
    started = false;
}
//# sourceMappingURL=telemetry.js.map